import { HttpClient } from '@angular/common/http';
import { IUser } from '../interfaces/user';
import { IUserFilter } from '../interfaces/user-filter';
import { EditService } from './edit.service';
import { Injectable } from '@angular/core';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';

@Injectable({ providedIn: 'root' })
export class RoleService extends EditService<IUser, IUserFilter> {
  url = '/api/roles';
  entityTitle = 'AccountCode';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  getRolesByOrg(orgId: number, orgType: number): Promise<any> {
    return this.http
      .get('api/roles/rolesbyorg?orgId=' + orgId + '&orgTypeId=' + orgType)
      .toPromise();
  }
}
